// extracted by mini-css-extract-plugin
export var body = "_e2-0";
export var sectionHeader = "_e2-4";
export var shortcutColumns = "_e2-2";
export var shortcutList = "_e2-1";
export var shortcutSection = "_e2-3";